import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export interface SignUpProps {
    urlParams: userPoolParams;
};
export interface userPoolParams {
    clientId: string;
    endpoint: string;
}

const SignUp: FC<SignUpProps> = (props) => {
    const location = useLocation();

    async function signUpWithRedirect(redirectUrl: string) {
        const rootPath = window.location.origin;
        const redirectUri = encodeURIComponent(`${rootPath}/signedup`);

        // The state parameter is used to pass the redirect URL to the sign up page.
        // The redirect URL is used to redirect the user back to the target page after sign up.
        // AWS Amplify does not support passing the redirect URL as a parameter to the sign up function.
        // We would need to add all target URLs to the list of allowed redirect URLs in the AWS Cognito console, which is not possible.
        // We need to double encode the state parameter because it will be decoded by AWS when the user is redirected after the signup.
        const state = encodeURIComponent(encodeURIComponent(JSON.stringify({ redirectTo: redirectUrl })));

        // As of today (2025-02-17), AWS Amplify does not support sign up with redirect (as we are using for the sign in).
        const signUpUrl = `https://${props.urlParams.endpoint}/signup?client_id=${props.urlParams.clientId}&redirect_uri=${redirectUri}&response_type=code&state=${state}`;

        window.location.href = signUpUrl;
    }

    useEffect(() => {
        const path = location?.state?.redirectTo ?? '/';
        void (async () => {
            await signUpWithRedirect(path);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default SignUp;